import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-cream" data-id="element-179">
      {/* Banner Image - Full bleed, header overlays on top */}
      <div className="w-full overflow-hidden relative" data-id="element-180">
        <img src="https://cdn.magicpatterns.com/uploads/jzj5MH1z54Mbq7NiheB7UQ/banner_optimo.png" alt="Ingri Lashes Banner" className="w-full h-auto object-cover" data-id="element-181" />
      </div>

      {/* Text Content Below Image */}
      <div className="max-w-6xl mx-auto px-6 text-center py-16 md:py-24 flex flex-col items-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-gold font-sans text-sm md:text-base uppercase tracking-[0.3em] mb-6 font-semibold" data-id="element-183">
          Bienvenida a tu mejor versión
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-ink leading-[1.2] mb-8 max-w-4xl" data-id="element-184">
          Una mirada bien enmarcada puede abrir puertas, crear conexiones y
          dejar huella.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-16" data-id="element-185">
          <span className="inline-block bg-blush/30 text-ink-dark font-serif text-xl md:text-2xl px-8 py-4 rounded-sm border border-gold/20 shadow-sm" data-id="element-186">
            Pestañas listas para impactar, precios listos para sorprenderte.
          </span>
        </motion.div>

        {/* Frases 2 - Elegant Quote Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16 w-full max-w-5xl" data-id="element-187">
          {['Acabo de darle un upgrade a mi mirada, y el mundo lo nota', 'Tu mirada merece atención profesional y yo puedo ser tu lashista de confianza', 'Cada par de pestañas que toco es un pequeño arte que cambia miradas.', 'Eleva tu mirada, cambia tu actitud.', 'Como lashista, hago que tu mirada hable sin decir una palabra.'].map((frase, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6 + idx * 0.1
        }} className={`bg-white p-8 rounded-sm shadow-sm border border-gold/10 flex items-center justify-center text-center ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-188">
              <p className="font-serif text-lg text-ink-light italic" data-id="element-189">
                "{frase}"
              </p>
            </motion.div>)}
        </div>

        <motion.a initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} href="https://wa.me/19295441537?text=Hola%20Ingri%2C%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold text-white px-10 py-4 text-sm uppercase tracking-widest font-bold hover:bg-gold-dark transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-190">
          Reservar Turno
        </motion.a>
      </div>
    </section>;
}